<template>
    <div class="choose-content">
        <p>{{$t('chooseGift.title')}}</p>
        <div class="row">
            <div
                class="col-6 col-sm-6 col-md-6 col-lg-3 col-xl-3 phone-goods"
                v-for="(item,index) in $store.state.giftsList"
                :key="index"
            >
                <div class="goods-list">
                    <div class="goods-list-img">
                        <img
                            class="w-100 h-100"
                            :src="item.cover"
                            :alt="item.name"
                        >
                    </div>
                    <p class="goods-list-title basic-font">{{item.name}}</p>
                    <div class="goods-list-btn row no-gutters justify-content-start">
                        <button
                            type="button"
                            class="common-comfirm-btn comfirm-btn-hover"
                            v-if="item.stock_sn>0"
                            @click="goOrder(item.id,item.name,item.kind,item.cover)"
                        >{{$t('chooseGift.btnWant')}}</button>
                        <button
                            type="button"
                            class="common-comfirm-btn  stock-btn"
                            disabled
                            v-else
                        >{{$t('chooseGift.btnStockout')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <!--上拉分页组件 v-if="isScrollLodingShow" ref="infiniteLoading"-->
        <div
            class="show-phone mt-4"
            v-if="isScrollLodingShow"
        >
            <infinite-loading
                :distance="50"
                throttleLimit="1000"
                @infinite="infiniteHandler"
            >
                <!-- <div slot="spinner">Loading...</div> -->
                <div slot="no-more">No more data</div>
            </infinite-loading>
        </div>

        <!-- 分页组件 -->
        <div
            class="pagination-box show-pc"
            v-if="totalPage>0"
        >
            <pagination
                v-on:gotoPage="gotoPage"
                :total="totalPage"
                :current="currentPage"
                :currentPrev="currentPage-1"
                :currentNext="currentPage+1"
                v-show="true"
                :showFirst="isFirst"
            ></pagination>
        </div>
    </div>
</template>

<script>

import Pagination from '../components/pagination'
import InfiniteLoading from 'vue-infinite-loading'

export default {
    name: 'Choose',
    data() {
        return {
            totalPage: 0,
            currentPage: 1,
            isFirst: false,
            isScrollLodingShow: false
        }
    },
    components: {
        Pagination,
        InfiniteLoading
    },
    mounted() {
        this.initData()
        this.getGiftsList()

        if (this.$isMobile()) { // 移动端
            this.isScrollLodingShow = true
        } else { // pc端
            this.isScrollLodingShow = false
        }
    },
    methods: {
        // 获取礼物列表
        getGiftsList() {
            let shopID = this.$store.state.shopID // 店铺id 
            let currentPage = this.currentPage
            // console.info('shopID=', shopID, ',currentPage=', currentPage)
            this.$get(`/api/v1/shops/${shopID}/gifts?page=${currentPage}&&per=8`).then(data => {
                let gifts = data.gifts
                this.totalPage = gifts.total_pages
                if (this.$isMobile()) { // 移动端
                    this.$store.commit('getGiftsListScroll', gifts.gifts)
                } else { // pc端
                    this.$store.commit('getGiftsList', gifts.gifts)
                }
            }).catch(err => {
                console.info(err)
            })

        },
        // 点击页码分页
        gotoPage(currentPage) {
            this.$store.commit("getGiftsList", []) //初始化礼物列表

            if (currentPage >= 1) {
                this.showFirst = true
            } else {
                this.showFirst = false
            }
            this.currentPage = currentPage //更新当前页码
            this.getGiftsList()
        },

        // 滚动分页，上拉无限加载
        infiniteHandler($state) {
            let shopID = this.$store.state.shopID // 店铺id
            this.currentPage = this.currentPage + 1
            // console.info('shopID=', shopID, ',currentPage=', this.currentPage)
            this.$get(`/api/v1/shops/${shopID}/gifts?page=${this.currentPage}&&per=8`).then(data => {
                let gifts = data.gifts
                if (this.currentPage <= this.totalPage) {
                    this.$store.commit('getGiftsListScroll', gifts.gifts)
                    $state.loaded()
                } else {
                    $state.complete()
                }
            }).catch(err => {
                console.info(err)
            })

        },
        // 点击i want 带订单id 跳转order页面
        goOrder(giftID, giftName, giftType, giftImage) {
            this.$router.push({ path: '/order', query: { 'giftID': giftID, 'giftName': giftName, 'giftType': giftType, 'giftImage': giftImage } })
        },
        //初始化数据
        initData() {
            this.$store.commit("getGiftsList", [])
            this.$store.commit("getGiftsListScroll", [])
            this.totalPage = 0
            this.currentPage = 1
            this.isFirst = false
            this.isScrollLodingShow = false
        },
        // watch: {
        //     //监听路由变化
        //     $route() { 
        //     }
        // },
        destroyed() { // 组件销毁时            
            this.initData()
        }
    }
}
</script>

<style scoped>
.choose-content > p {
    margin-bottom: 20px;
    font-size: 34px;
    font-weight: 500;
}

.goods-list {
    margin-top: 35px;
    width: 240px;
}

.goods-list-img {
    width: 240px;
    height: 302px;
    background: #aaa;
    overflow: hidden;
}

.goods-list-img img {
    object-fit: cover;
}

.goods-list-img:hover img {
    animation: kfr-img 0.2s forwards ease;
}
@keyframes kfr-img {
    to {
        transform: scale(1.2);
    }
}

.goods-list-title {
    margin: 15px 0 20px 0;
    font-weight: 500;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.goods-list-btn button {
    height: 35px;
    line-height: 35px;
    width: 132px;
    font-size: 16px;
}

.comfirm-btn-hover {
    transition: background-color 0.2s;
}

.comfirm-btn-hover:hover {
    background-color: rgb(245, 185, 74);
}

.stock-btn {
    background: #ccc;
}

.pagination-box {
    margin-top: 30px;
}

/*适配手机*/

@media only screen and (min-width: 320px) and (max-width: 767px) {
    .choose-content {
        padding: 25px 15px;
    }
    .choose-content > p {
        font-size: 23px;
    }
    .goods-list {
        width: 160px;
        margin-top: 20px;
    }
    .goods-list-img {
        width: 160px;
        height: 196px;
    }
    .goods-list-title {
        margin: 8px 0;
    }
    .goods-list-btn button {
        width: 75px;
        height: 23px;
        line-height: 23px;
        font-size: 12px;
    }
    .phone-goods {
        display: flex;
        justify-content: center;
    }
}
</style>